// extracted by mini-css-extract-plugin
export default {"googleBtn":"GoogleAuthBtn_googleBtn__-Q9wN","googleBtnText":"GoogleAuthBtn_googleBtnText__K1-3h"};